import React, { useState, useEffect } from "react";
import styles from "./Admin.module.css";
import {
  singUpUserRequestAdmin,
  getUsersInformationRequest,
  deleteUserAdmin,
} from "./signIn/api/index";
export const Admin = () => {
  const [applications, setApplications] = useState([
    {
      id: "1",
      name: "John Doe",
      email: "john.doe@example.com",
      password: "Frontend Developer",
      status: "pending",
      createdAt: "2024-01-15",
    },
    {
      id: "2",
      name: "Jane Smith",
      email: "jane.smith@example.com",
      password: "UI/UX Designer",
      status: "approved",
      createdAt: "2024-01-14",
    },
  ]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await getUsersInformationRequest();
        setApplications(res.users || []);
      } catch (error) {
        console.error("Failed to load users:", error);
      }
    };

    fetchUsers();
  }, []);
  const handleAddApplication = async (e) => {
    e.preventDefault();
    const newApplication = {
      id: Date.now().toString(),
      name: formData.name,
      email: formData.email,
      password: formData.password,
      status: "pending",
      createdAt: new Date().toISOString().split("T")[0],
    };

    await singUpUserRequestAdmin(formData);

    setApplications([...applications, newApplication]);
    setFormData({ name: "", email: "", password: "" });
  };

  const handleDeleteApplication = async (id) => {
    setApplications(applications.filter((app) => app.id !== id));
    console.log(
      "-=-=-=-applications-=-=-",
      applications.filter((app) => app.id !== id)
    );
    const deleteUserId = applications.filter((app) => app.id !== id);
    const test = await deleteUserAdmin(id);
    console.log("-=-=-test--=-=-", test);
  };

  const handleStatusChange = (id, status) => {
    setApplications(
      applications.map((app) => (app.id === id ? { ...app, status } : app))
    );
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Admin Dashboard</h1>
        <p className={styles.subtitle}>Manage user applications</p>
      </div>

      <div className={styles.grid}>
        {/* Add Application Form */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <h2 className={styles.cardTitle}>Add New Application</h2>
          </div>
          <form onSubmit={handleAddApplication} className={styles.form}>
            <div className={styles.inputGroup}>
              <label htmlFor="name" className={styles.label}>
                Full Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="email" className={styles.label}>
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="password" className={styles.label}>
                Password
              </label>
              <input
                type="text"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required
                className={styles.input}
              />
            </div>
            <button type="submit" className={styles.addButton}>
              Create User
            </button>
          </form>

          {/* <button>Log Out</button> */}
        </div>

        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <h2 className={styles.cardTitle}>User Applications</h2>
            <span className={styles.count}>{applications.length} total</span>
          </div>
          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Position</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((app) => (
                  <tr key={app.id}>
                    <td className={styles.name}>{app.name}</td>
                    <td className={styles.email}>{app.email}</td>
                    <td>{app.position}</td>
                    <td>
                      <select
                        value={app.status}
                        onChange={(e) =>
                          handleStatusChange(app.id, e.target.value)
                        }
                        className={`${styles.statusSelect} ${
                          styles[app.status]
                        }`}
                      >
                        <option value="pending">Pending</option>
                        <option value="approved">Approved</option>
                        <option value="rejected">Rejected</option>
                      </select>
                    </td>
                    <td>{app.createdAt}</td>
                    <td>
                      <button
                        onClick={() => handleDeleteApplication(app.id)}
                        className={styles.deleteButton}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
